import Link from "@components/common/ui/Link";
import { useAffiliateData } from "@hooks/affiliates/affiliate/useAffiliateData";
import { Logo } from "@kirvanobr/logo";
import { useRouter } from "next/router";
import * as S from "./styles";
import { Button } from "@kirvanobr/button";

export default function Header() {
  const { acceptAffiliation, data } = useAffiliateData();

  const router = useRouter();
  const acceptAndRedirect = () => {
    acceptAffiliation();
    router.push("/");
  };

  if (!data) return <></>;
  const { affiliatesEnabled } = data;
  return (
    <S.Header>
      <S.HeaderContainer>
        <Link path="/">
          <Logo variant="full" fontSize={18} className="!text-foreground" />
        </Link>

        {affiliatesEnabled && (
          <Button onClick={acceptAndRedirect} variant="link" endContent={<S.ArrowIcon />}>
            Próxima etapa
          </Button>
        )}
      </S.HeaderContainer>
    </S.Header>
  );
}
